import { defineMessages } from 'react-intl'

export default defineMessages({
  createTitle: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.Header.NewChannelConnection',
    defaultMessage: 'Create a new channel connection'
  },
  editTitle: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.Header.EditChannelConnection',
    defaultMessage: 'Edit an existing channel connection'
  },
  channelConnectionNameLabel: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.Name.label',
    defaultMessage: 'Channel Connection Name'
  },
  channelConnectionNamePlaceholder: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.Name.Placeholder',
    defaultMessage: 'Production Intranet Site'
  },
  channelConnectionNameRequiredError: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.Name.required.error',
    defaultMessage: 'Enter a name for your Channel Connection'
  },
  channelConnectionNameMinError: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.Name.min.error',
    defaultMessage: 'Channel Connection name must be at least 2 characters'
  },
  channelConnectionIdOIDCLabel: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.ChannelConnectionId.OIDC.label',
    defaultMessage: 'Igloo Workplace ID'
  },
  channelConnectionIdOIDCHint: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.ChannelConnectionId.OIDC.hint',
    defaultMessage: 'The Igloo Digital Workplace ID to link this assistant.'
  },
  channelConnectionIdPlaceholder: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.ChannelConnectionId.Placeholder',
    defaultMessage: '26ba412e-4838-43b7-b88d-0d00adf6bb67'
  },
  channelConnectionIdRequiredError: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.ChannelConnectionId.required.error',
    defaultMessage: 'Enter a Channel Connection ID'
  },
  channelConnectionChannelLabel: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.ChannelConnectionChannel.label',
    defaultMessage: 'What would you like to connect?'
  },
  channelConnectionChannelLabelEditing: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.ChannelConnectionChannel.label',
    defaultMessage: 'Channel'
  },
  channelConnectionJWKSURILabel: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.channelConnectionJWKSURILabel.label',
    defaultMessage: 'JWKS URI'
  },
  channelConnectionJWKSURIPlaceholder: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.ChannelConnectionJWKSURI.Placeholder',
    defaultMessage:
      'https://apis.flex-live.net/flex/WorkgridService/workplace/d32aea05-4fbd-4356-87b4-0d00adf6bb67/jwks?TenantId=846685ab-34db-5872-b7ba-0d00adf6bb67'
  },
  channelConnectionJWKSURIRequiredError: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.ChannelConnectionJWKSURI.required.error',
    defaultMessage: 'Enter a valid JWKS URI'
  },
  create: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.Create',
    defaultMessage: 'Connect'
  },
  cancel: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.Cancel',
    defaultMessage: 'Cancel'
  },
  update: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.Update',
    defaultMessage: 'Update'
  },
  oidcLabel: {
    id: 'OrganizationChannelConnectionsPage.CreateChannelConnection.OIDC.Label',
    defaultMessage: 'OIDC (Igloo)'
  }
})
